import { BrowserRouter, Routes, Route } from "react-router-dom"

import Home from "./pages/Home";
import Login from "./components/Login";
import Users from "./pages/Users";
import Sensors from "./pages/Sensors";
import AddUser from "./pages/AddUser";
import EditUser from "./pages/EditUser";
import EditSensor from "./pages/EditSensor";
import AddSensor from "./pages/AddSensor";
import DashboardPage from "./pages/DashboardPage";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/edit/:id" element={<EditUser />} />
          <Route path="/sensors" element={<Sensors />} />
          <Route path="/sensors/add" element={<AddSensor />} />
          <Route path="/sensors/edit/:id" element={<EditSensor />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
